import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  CssBaseline,
  Container,
  Box,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { addPrivacyPolicy, removePrivacyPolicyItem } from '../../redux/reducers/LegalInformationsReducer';

function PrivacyPolicyTab() {
  const privacyPolicyData = useSelector((state) => state.legalInformations.privacyPolicyData);
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [newItem, setNewItem] = useState({ title: '', description: '' });

  const handleDelete = (uid) => {
    dispatch(removePrivacyPolicyItem(uid));
  };

  const handleAdd = () => {
    dispatch(addPrivacyPolicy(newItem));
    setNewItem({ title: '', description: '' });
    setOpenDialog(false);
  };

  return (
    <Container component="main" maxWidth="lg">
      <CssBaseline />
      <Box display="flex" justifyContent="center" mt={2}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenDialog(true)}
          style={{ backgroundColor: '#FC6258', color: 'white', textTransform: 'none' }}
        >
          Ajouter
        </Button>
      </Box>
      <div>
        <Typography variant="h4" gutterBottom>
          Politique de confidentialité
        </Typography>
        <List>
          {privacyPolicyData.map((item) => (
            <ListItem key={item.uid} style={{ borderBottom: '1px solid #ccc' }}>
              <ListItemText primary={item.title} secondary={item.description} />
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(item.uid)}>
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </div>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Ajouter de nouvelles politiques de confidentialité</DialogTitle>
        <DialogContent>
          <TextField
            label="Titre"
            fullWidth
            value={newItem.title}
            onChange={(e) => setNewItem({ ...newItem, title: e.target.value })}
            margin="normal"
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            rows={4}
            value={newItem.description}
            onChange={(e) => setNewItem({ ...newItem, description: e.target.value })}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
        <Button onClick={() => setOpenDialog(false)} style={{ color: '#FC6258' }}>
  Annuler
</Button>
<Button onClick={handleAdd} variant="contained" style={{ backgroundColor: '#FC6258', color: 'white' }}>
  Ajouter
</Button>

        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default PrivacyPolicyTab;
